import React, { Component } from "react";

export default class Footer extends Component {
  render() {
    return (
      <React.Fragment>
        <h5>404: La ruta actual no existe.</h5>
      </React.Fragment>
    );
  }
}
